import { xhrRequest } from '../../shared/helpers';

export default class extends Controller {
  static targets = ['form'];

  connect() {
    if (this.hasFormTarget) {
      $(this.formTarget).on('ajax:complete', (event, xhr, status) => {
        App.Modal.closeAll();
        if (status != 'success') this.openVexModal(xhr.responseText);
      });
    }
  }

  openForm(event) {
    event && event.preventDefault();
    xhrRequest(this.url, 'get').then(({ data }) => {
      App.Modal.closeAll();
      this.openVexModal(data);
    });
  }

  closeForm(event) {
    event && event.preventDefault();
    App.Modal.closeAll();
  }

  openVexModal(content) {
    App.Modal.open({
      content,
      showCloseButton: false,
      contentClassName: 'notification-settings-modal'
    })
  }

  get url() {
    return this.data.get('url');
  }
};


// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/notification-settings-controller.js